import React, { Fragment, Component } from "react";
import { ListItem, f7 } from "framework7-react";
import _ from "lodash";

export default class SmartSelect extends Component {
  constructor(props) {
    super(props);

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.renderOption = this.renderOption.bind(this);
    this.getValue = this.getValue.bind(this);
    this.getLabel = this.getLabel.bind(this);
    this.getOptions = this.getOptions.bind(this);

    this.f7Ref = React.createRef();
  }

  getOptions() {
    const { options, favourite_id } = this.props;
    // Favourite options handling START
    let options_converted = [];
    const favourite_options = _.filter(options, (o) => o[favourite_id] == true);
    const non_favourite_options = _.filter(options, (o) => o[favourite_id] != true);
    if (favourite_id && _.isNotEmpty(favourite_options)) {
      options_converted.push({
        label: "Favourites",
        options: favourite_options,
      });

      options_converted.push({
        label: "Remaining Options",
        options: non_favourite_options,
      });
    } else {
      options_converted = _.cloneDeep(options);
    }
    // Favourite options handling END

    return options_converted;
  }

  componentDidUpdate(prevProps) {
    if (this.props.input.value !== prevProps.input.value) {
      const smartSelect = this.f7Ref.f7SmartSelect;
      if (_.isFunction(smartSelect)) {
        if (smartSelect()) {
          const label = this.getLabel();
          if (label) smartSelect().setValueText(label);
        }
      }
    }
  }

  renderOption(option, i) {
    const { labelName, valueName } = this.props;

    if (option.options) {
      return (
        <optgroup key={i} label={option.label}>
          {_.map(option.options, (o) => this.renderOption(o, `${option.label}-${i}`))}
        </optgroup>
      );
    } else {
      return (
        <option value={option[valueName]} key={i} disabled={option.isDisabled}>
          {option[labelName]}
        </option>
      );
    }
  }

  onChangeHandler(event) {
    const {
      options,
      valueName,
      input: { onChange },
      multi,
    } = this.props;

    if (multi) {
      const selectedOptions = Array.from(event.target.selectedOptions);
      const newSelectedValues = _.map(selectedOptions, (o) => o.value);

      let newFieldValues = _.map(newSelectedValues, (v) => _.find(options, (o) => o[valueName] == v));

      onChange(newFieldValues);
    } else {
      onChange(event.target.value);
    }
  }

  getValue() {
    const {
      input: { value },
      valueName,
      multi,
    } = this.props;
    let transformedValue = value;
    if (multi) {
      transformedValue = _.map(value, (v) => v[valueName]);
    }
    return transformedValue;
  }

  getLabel() {
    const { options, labelName, valueName, multi } = this.props;
    const value = this.getValue();

    if (multi) {
      return _.map(value, (v) => _.find(options, (o) => o?.[valueName] == v)?.[labelName]).join(", ");
    } else {
      return _.get(
        _.find(options, (o) => o[valueName] == value),
        labelName
      );
    }
  }

  render() {
    const {
      input: { value, onBlur, name },
      meta: { touched, error },
      label,
      placeholder,
      options,
      openIn,
      searchbar,
      searchbarPlaceholder,
      closeOnSelect,
      multi,
      after,
      virtualList,
      backupLabel,
      style
    } = this.props;

    const transformedValue = this.getValue();
    let errorDisplay;
    if (_.isObject(error)) {
      errorDisplay = _.get(error, name);
    } else {
      errorDisplay = error;
    }

    let extraOption;
    const options_converted = this.getOptions();
    const flatOptions = _.flatten(_.map(options_converted, (o) => (o.options ? o.options : o)));
    const findOption = _.find(flatOptions, (o) => o.value == value);
    if (!findOption && backupLabel) {
      extraOption = { value: value, label: backupLabel };
    }

    // console.log(name, value, transformedValue);

    return (
      <Fragment>
        {_.isEmpty(options_converted) && <ListItem>No {label} options</ListItem>}
        {_.isNotEmpty(options_converted) && (
          <ListItem
            title={label}
            style={style}
            after={after}
            smartSelect
            smartSelectParams={{
              openIn: openIn,
              searchbar: searchbar,
              searchbarPlaceholder: searchbarPlaceholder,
              closeOnSelect: closeOnSelect,
              on: {
                smartSelectClosed: onBlur,
              },
              virtualList: virtualList,
            }}
            ref={(el) => {
              this.f7Ref = el;
            }}
          >
            <select multiple={multi} name={name} onChange={this.onChangeHandler} value={transformedValue}>
              {placeholder && !multi && <option disabled={value}>{placeholder}</option>}
              {_.map(options_converted, (o, i) => {
                return this.renderOption(o, i);
              })}
              {extraOption && <Fragment>{this.renderOption(extraOption)}</Fragment>}
            </select>
          </ListItem>
        )}
        {touched && errorDisplay ? (
          <div className="margin-left text-color-red">
            <small>{errorDisplay}</small>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

SmartSelect.defaultProps = {
  openIn: "popup",
  searchbar: false,
  searchbarPlaceholder: null,
  closeOnSelect: true,
  placeholder: "Select",
  label: "",
  multi: false,
  valueName: "id",
  labelName: "name",
};
